import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { AlphanumCodes } from 'src/app/models/alphanumcodes.model';
import { FormField } from 'src/app/models/rich-data.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-alphanum-inputs',
  templateUrl: './alphanum-inputs.component.html',
  styleUrls: ['./alphanum-inputs.component.scss', '../extra-forms/extra-forms.component.scss']
})
export class AlphanumInputsComponent implements OnInit {
  @Input() field: FormField;
  alphanumCodes: AlphanumCodes[];

  constructor(
    private httpClient: HttpClient,
  ) { }

  async ngOnInit() {
    this.alphanumCodes = await this.getFieldOptionsById(this.field.id);

    if(this.field.field_type === 9) {
      this.field.value = '';
    }
  }

  getFieldOptionsById(id: number): Promise<AlphanumCodes[]> {
    return new Promise((resolve, reject)=>{
      this.httpClient.get<AlphanumCodes[]>(environment.exApiURL + '/alphanumcode/FormField_' + id).subscribe({
        next: (data) => {
          resolve(data);
        },
        error: (error) => {
          reject(error);
        }
      });
    });
  };

  onCheckBoxChange(boxValue: string) {
    if(this.field.value.includes(boxValue)) {
      const INDEX = this.field.value.indexOf(boxValue);
      const newValue = this.field.value.slice(0, INDEX) + this.field.value.slice(INDEX + boxValue.length+1);
      this.field.value = newValue;
    } else{
      this.field.value = this.field.value + boxValue + ',';
    }
  }

}
